import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { BackgroundJobScheduleDto } from "@/api/dtos";
import type { BackgroundJobSchedule, BackgroundJobScheduleInput } from "./_models/BackgroundJobSchedule";
import { toBackgroundJobScheduleFromBackgroundJobScheduleDto } from "./_transformers/toBackgroundJobScheduleFromBackgroundJobScheduleDto";
import { toBackgroundJobFetchError } from "./backgroundJob.utils";
import { BackgroundJobTags } from "./BackgroundJobTags";

/** Creates a schedule (POST /background-job-schedules) and, deployed, its EventBridge schedule. WRITE. */
export const createBackgroundJobScheduleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createBackgroundJobSchedule: builder.mutation<BackgroundJobSchedule, BackgroundJobScheduleInput>({
      queryFn: async (schedule) => {
        try {
          const res = await axios.post<BackgroundJobScheduleDto>(
            `${backendBase()}/background-job-schedules`,
            schedule,
            { headers: { Accept: "application/json" } },
          );
          const saved = toBackgroundJobScheduleFromBackgroundJobScheduleDto(res.data);
          return { data: saved };
        }
        catch (e) {
          return { error: toBackgroundJobFetchError(e) };
        }
      },
      invalidatesTags: [{ type: BackgroundJobTags.BackgroundJobSchedule, id: "LIST" }],
    }),
  }),
});

export const createBackgroundJobSchedule = createBackgroundJobScheduleApi.endpoints.createBackgroundJobSchedule;
